const existingSupplierDetails = (state = {}, action) => {
  switch (action.type) {
    case "existingSupplierDetails":
      return action.payload;
    default:
      return state;
  }
};

export default existingSupplierDetails;
